<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { useCourseStore } from '@/stores/courseStore';
import vMenuVue from './vMenu.vue';
import { menuStore } from '@/stores/menuStore';
import { useRoute } from 'vue-router';
import { Back } from '@element-plus/icons-vue';

const route = useRoute();
const courseStore = useCourseStore();
const mStore = menuStore();
const isLoading = ref(true);

onMounted(async () => {
    // Launch courseList just for preload. No await
    courseStore.getCourses(false);
    await load();
});

watch(() => route.query.main ?? '', async () => {
    await load();
});

const load = async () => {
    isLoading.value = true;
    try {
        await mStore.loadContent("mainMenu");
        mStore.loadSubMenu("mainMenu", route.query.main as string, "mainMenuSub");
    } finally {
        isLoading.value = false;
    }
}
</script>

<template>
    <div>
        <!-- Projects grid -->
        <div v-if="isLoading" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10"
            aria-busy="true" aria-label="Lade Kurse">
            <div v-for="item in 6" :key="item"
                class="mb-10 overflow-hidden rounded-xl border border-gray-300 bg-gray-300 shadow-lg sm:mb-0">
                <div class="h-80 animate-pulse bg-gray-400"></div>
                <div class="space-y-3 px-4 py-6">
                    <div class="mx-auto h-5 w-3/4 animate-pulse rounded bg-gray-400"></div>
                    <div class="mx-auto h-4 w-1/2 animate-pulse rounded bg-gray-400"></div>
                </div>
            </div>
        </div>
        <div class="w-full" v-if="!isLoading && mStore.menu && mStore.menu['mainMenuSub']">
            <RouterLink :to="{ name: 'home' }"><el-icon size="12"><Back /></el-icon> Torna al menu principale</RouterLink>
            <h2 class="mt-3">{{ mStore.menu["mainMenuSub"].title }}</h2>
            <span v-html="mStore.menu['mainMenuSub'].description"></span>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10">
                <vMenuVue id="mainMenuSub" :noload="true" class="flex-auto flex w-64" layout="cards"></vMenuVue>
            </div>
        </div>
        <div v-else-if="!isLoading" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10">
            <vMenuVue id="mainMenu" class="flex-auto flex w-64" layout="cards"></vMenuVue>
        </div>
    </div>
</template>
